import axios from "axios";

export interface UserRole {
  id: string;
  label: string;
  isDisabled: boolean;
}

export function getAllRoles() {
  return axios.get<UserRole[]>("/Groups/lookups").then((res) => res.data);
}

export function getUserGroupsByCompany(userId: string, companyId?: string) {
  return axios
    .get<
      {
        companyId: string;
        companyLocationId: string;
        role: number;
      }[]
    >(
      `/user-groups/getusergroupsbyusername?username=${userId}${
        companyId ? `&companyId=${companyId}` : ""
      }`,
    )
    .then((res) => res.data);
}
